module.exports = __webpack_public_path__ + "static/media/shopping_boatyard_marker.53cb91b5.svg";